import { defineStore } from 'pinia';
import { useChartStyleButtons } from '@/composables/useChartStyleButtons';
import { sortObjectsClosure } from '@/utils/sortObjectsClosure';
import { INVALID_CHART_RECID } from '@/composables/isValidChartRecid';
import { INVALID_CHART_STYLE_RECID } from '@/composables/isValidChartStyleRecid';
import { SavedChartsStore } from '@/types/SavedChartsStore';

function stateFn(): SavedChartsStore {
  return {
    chartLists: [],
    chartStyles: [],
    sampleChartStyleGroups: [],
    recidOfDefaultChartStyle: INVALID_CHART_STYLE_RECID,
    recidOfChartStyleBeingPreviewedInChartLibraryListView: INVALID_CHART_STYLE_RECID,
    recidOfChartBeingPreviewedInChartLibraryListView: INVALID_CHART_RECID,
    recidOfChartStyleBeingDeletedInModalView: INVALID_CHART_STYLE_RECID,
    recidOfChartBeingDeletedInModalView: INVALID_CHART_RECID,
    recidOfChartStyleBeingEditedInModalView: INVALID_CHART_STYLE_RECID,
    recidOfChartBeingEditedInModalView: INVALID_CHART_RECID,
    chartStyleRecidBeingConfiguredInChartStyleButtonModal: INVALID_CHART_STYLE_RECID,
    isAttemptingToLoadChartStyles: true,
    hasAttemptedToLoadChartStyles: false,
    hasFailedToLoadChartStyles: false,
    isAttemptingToLoadChartLists: true,
    hasAttemptedToLoadChartLists: false,
    hasFailedToLoadChartLists: false
  };
}

const useSavedChartsStore = defineStore('savedChartsStore', {
  state: stateFn,
  getters: {
    chartStyleButtonChartStyles: function (state) {
      const { MAX_NUMBER_OF_CHART_STYLE_BUTTONS } = useChartStyleButtons();

      const chartStyleButtonChartStyles = state.chartStyles.filter(chartStyle => chartStyle.chartStyleButtonIndex >= 0);

      chartStyleButtonChartStyles.sort(sortObjectsClosure({
        propertyName: 'chartStyleButtonIndex',
        order: 'ascending'
      }));

      return chartStyleButtonChartStyles.slice(0, MAX_NUMBER_OF_CHART_STYLE_BUTTONS);
    },
    nonChartStyleButtonChartStyles: function (state) {
      const { MAX_NUMBER_OF_CHART_STYLE_BUTTONS } = useChartStyleButtons();

      let chartStyleButtonChartStyles = state.chartStyles.filter(chartStyle => chartStyle.chartStyleButtonIndex >= 0);

      chartStyleButtonChartStyles.sort(sortObjectsClosure({
        propertyName: 'chartStyleButtonIndex',
        order: 'ascending'
      }));

      chartStyleButtonChartStyles = chartStyleButtonChartStyles.slice(0, MAX_NUMBER_OF_CHART_STYLE_BUTTONS);

      return state.chartStyles.filter(chartStyle => !chartStyleButtonChartStyles.includes(chartStyle));
    }
  }
});

export {
  useSavedChartsStore
};
